export default "__VITE_ASSET__35575d39__"